import request from '@/service/request'

import store from '@/store'

const isAdmin = store.state.login.isAdmin
// 获取桌球室列表
export const pageSnookerRoomApi = (params) => {
  const url = isAdmin ? 'pageManager' : 'page'
  return request.post(`/stu/snookerRoom/${url}`, params)
}

/* 获取桌球室list
 * 超管 （查看所有数据）：/snookerRoom/listManager
 * 普通管理员(按管辖球场获取数据) ：/snookerRoom/list
 */
export const listSnookerRoomApi = (params) => {
  const url = isAdmin ? 'listManager' : 'list'
  return request.post(`/stu/snookerRoom/${url}`, params)
}

// 添加桌球室
export const saveSnookerRoomApi = (params) => {
  return request.post('/stu/snookerRoom/save', params)
}
/* 删除桌球室
* @params/id 桌球室id
* */
export const deleteSnookerRoom = (id) => {
  return request.post('/stu/snookerRoom/del/' + id)
}

// 根据id获取桌球室信息
export const getSnookerRoomByIdApi = (id) => {
  return request.post('/stu/snookerRoom/get/' + id)
}

/* 1桌球室管理，根据校区批量绑定管理员
* @params {string} campusId 校区id
* @params {array} userIds 用户id list
* @params {number} userType 用户类型： 2-学生 3-教职工
* */
export const batchBindManagersBySnookerRoomApi = (params) => {
  return request.post('/stu/snookerManagerUser/bindBatch', params)
}
/* 桌球室管理，根据校区id获取学生核销员list
* @params {string} campusId
* */
export const listSnookerRoomStuApi = (params) => {
  return request.post('/stu/snookerManagerUser/listByStu', params)
}
/* 桌球室管理，根据校区id获取教职工核销员list
* @params {string} campusId
* */
export const listSnookerRoomTeacherApi = (params) => {
  return request.post('/stu/snookerManagerUser/list', params)
}
